import React, { useState } from 'react';
import LoginForm from '../components/LoginForm';
import authService from '../services/authService';
import { Box } from '@mui/material';
import photoFCN from '../assets/logo.jpg'; // Using the logo as a placeholder, replace with the actual image if available

const LoginPage: React.FC = () => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (email: string, password: string) => {
    setError('');
    setIsLoading(true);

    try {
      const data = await authService.login(email, password);
      console.log('Login successful:', data);
      // Redirect on successful login
      window.location.href = '/clients';
    } catch (error) {
      setError('Credenciales inválidas, por favor intente nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        height: '100vh',
        width: '100vw',
        backgroundColor: '#242424',
        color: '#FFFFFF',
      }}
    >
      <Box
        component="img"
        src={photoFCN}
        alt="Login Visual"
        sx={{
          width: { xs: '0', md: '65%' },
          height: '100%',
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      />
      <Box
        sx={{
          width: { xs: '100%', md: '35%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '2rem',
        }}
      >
        <LoginForm onLogin={handleLogin} error={error} isLoading={isLoading} />
      </Box>
    </Box>
  );
};

export default LoginPage;